import {
  DotLottie,
  type DotLottieReactProps,
} from '@lottiefiles/dotlottie-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import LottiePlayer from '~/src/components/LottiePlayer'
import LogoIcon from '~/src/components/svg/LogoIcon'

interface Props extends Omit<DotLottieReactProps, 'src' | 'autoplay'> {
  forceTheme?: 'light' | 'dark'
}

const AnimatedDupeLogo: React.FC<Props> = ({ forceTheme, ...props }) => {
  const { resolvedTheme, theme } = useTheme()
  const isDarkMode = forceTheme
    ? forceTheme === 'dark'
    : resolvedTheme === 'dark' || theme === 'dark'

  const [dotLottie, setDotLottie] = useState<DotLottie>()
  const [showPlaceholder, setShowPlaceholder] = useState(true)

  const dotLottieRefCallback = (dotLottie: DotLottie) => {
    setDotLottie(dotLottie)
  }

  useEffect(() => {
    if (!dotLottie) return

    const timer = setTimeout(() => {
      setShowPlaceholder(false)
    }, 300)

    return () => clearTimeout(timer)
  }, [dotLottie])

  return (
    <div className='relative flex h-[50px] w-full items-center justify-center md:h-[110px]'>
      <div className='absolute inset-x-0 flex h-[50px] items-center justify-center md:h-[110px]'>
        {isDarkMode ? (
          <LottiePlayer
            {...props}
            key='dark-mode'
            src={
              'https://lottie.host/c2a0caf3-cab9-42e4-afb6-98847c43e8fb/kqAlmuIxCT.lottie'
            }
            autoplay
            style={{
              height: '350%',
            }}
            dotLottieRefCallback={dotLottieRefCallback}
          />
        ) : (
          <LottiePlayer
            {...props}
            key='light-mode'
            src={
              'https://lottie.host/d7fbbd33-255a-4582-96c0-6d0d1b0e124d/CFRHNV4AJc.lottie'
            }
            autoplay
            style={{
              height: '350%',
            }}
            dotLottieRefCallback={dotLottieRefCallback}
          />
        )}
      </div>
      {showPlaceholder && (
        <LogoIcon
          className='relative z-10 h-[51.5px] w-auto md:h-[116px]'
          fill={isDarkMode ? 'white' : 'black'}
          style={{
            transform: 'rotate(3deg)',
          }}
        />
      )}
    </div>
  )
}

export default AnimatedDupeLogo
